export const Studies = [
  { label: 'ml.studies.basics', value: 0 },
  { label: 'ml.studies.mediumDegree', value: 1 },
  { label: 'ml.studies.highSchool', value: 2 },
  { label: 'ml.studies.superiorDegree', value: 3 },
  { label: 'ml.studies.career', value: 4 },
  { label: 'ml.studies.continousLearning', value: 5 },
];

export const Cities = [
  { label: 'ml.cities.salamanca', value: 0 },
  { label: 'ml.cities.valladolid', value: 1 },
  { label: 'ml.cities.valencia', value: 2 },
  { label: 'ml.cities.madrid', value: 3 },
  { label: 'ml.cities.lA', value: 4 },
  { label: 'ml.cities.nY', value: 5 },
  { label: 'ml.cities.zurich', value: 6 },
];

export const Ages = [
  { label: '15-19', value: 0 },
  { label: '20-24', value: 1 },
  { label: '25-29', value: 2 },
  { label: '30-34', value: 3 },
  { label: '35-39', value: 4 },
  { label: '40-44', value: 5 },
  { label: '45-49', value: 6 },
  { label: '50-54', value: 7 },
  { label: '55-59', value: 8 },
  { label: '60-65', value: 9 },
];

export const Childs = [
  { label: '0', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
];

export const CivilStatus = [
  { label: 'ml.civilStatus.divorced', value: 0 },
  { label: 'ml.civilStatus.single', value: 1 },
  { label: 'ml.civilStatus.widower', value: 2 },
  { label: 'ml.civilStatus.married', value: 3 },
];

export const Gender = [
  { label: 'ml.gender.others', value: 0 },
  { label: 'ml.gender.female', value: 1 },
  { label: 'ml.gender.male', value: 2 },
];

export const Bank = [
  { label: 'BBVA', value: 0 },
  { label: 'La Caixa', value: 1 },
  { label: 'ING', value: 2 },
  { label: 'KBC', value: 3 },
  { label: 'Rabbobank', value: 4 },
  { label: 'Santander', value: 5 },
];
